<button class="ui main-button-color fluid button search-report" [ngClass]="{'loading': !state.loaded}"
    style="height: 36px !important; margin-top: 24px; margin-right: 0"
    [textContent]="state.initialLoad ? 'ПОКАЗАТЬ' : 'ОБНОВИТЬ'">
</button>